import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  },
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Denomination</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map((itemclass, index) => (
            <TableRow key={index}>
              <TableCell className={clsx(classes.header)}>
                <div>{itemclass.label}</div>
                <div><Typography variant="caption">{itemclass.reference}</Typography></div>
              </TableCell>
              <TableCell>
                {itemclass.denomination || "0"}
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/item-classes/${itemclass.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;